var CryptoJS = require("crypto-js");

export const decrypt = (text, key) => {
    if(key !== '' && key != null){
        try{
            const bytes  = CryptoJS.AES.decrypt(text, key);
            const originalText = bytes.toString(CryptoJS.enc.Utf8);
            return originalText
        }catch{
            return text
        }
    }else{
        return text
    }
    
}

export const encrypt = (text, key) =>{
    return !!key ? CryptoJS.AES.encrypt(text, key).toString() : text;
}

// CryptoJS writes OpenSSL-compatible output, which always opens with the base64
// of the "Salted__" header. It is the only signal we have that a stored value is
// ciphertext: notes saved before a secret key existed are plain text (see encrypt).
const SALTED_PREFIX = 'U2FsdGVkX1'

// A wrong key normally decrypts to an empty string or throws on malformed UTF-8,
// but it occasionally produces control characters that pass as a valid string.
const UNREADABLE = /[\u0000-\u0008\u000B\u000C\u000E-\u001F\uFFFD]/

export const SECRET_KEY_STORAGE = 'secret_key'
// A separate slot on purpose: src/components/early/ reads 'secret_key' as a {userId: key}
// map, so the ring must not share that name.
export const SECRET_KEYS_STORAGE = 'secret_keys'
export const SECRET_KEY_EVENT = 'secret-key-changed'

export const isEncrypted = (value) => typeof value === 'string' && value.startsWith(SALTED_PREFIX)

const toBytes = (wordArray) => {
    const bytes = []
    for (let i = 0; i < wordArray.sigBytes; i++) bytes.push((wordArray.words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff)
    return bytes
}

/**
 * CryptoJS strips PKCS7 padding without checking it, which is why a wrong key so often
 * yields an empty string rather than an error. Validating the padding ourselves turns a
 * wrong key into a near-certain rejection (0 false accepts in 50k wrong keys, vs 0.31%
 * without), and lets a genuinely empty field be told apart from a failed decrypt.
 */
const decryptStrict = (text, key) => {
    try {
        const padded = CryptoJS.AES.decrypt(text, key, { padding: CryptoJS.pad.NoPadding })
        const bytes = toBytes(padded)
        if (bytes.length === 0 || bytes.length % 16 !== 0) return null

        const padding = bytes[bytes.length - 1]
        if (padding < 1 || padding > 16 || padding > bytes.length) return null
        for (let i = bytes.length - padding; i < bytes.length; i++) {
            if (bytes[i] !== padding) return null
        }

        const value = CryptoJS.lib.WordArray.create(padded.words.slice(), bytes.length - padding).toString(CryptoJS.enc.Utf8)
        return UNREADABLE.test(value) ? null : value
    } catch {
        return null
    }
}

/**
 * Reads one stored value. `value` is never ciphertext, so a caller that ignores the
 * flags still cannot leak one.
 *   encrypted - the stored value is ciphertext
 *   readable  - this key decrypted it, empty result included
 */
export const readSecret = (text, key) => {
    if (typeof text !== 'string' || text === '') return { encrypted: false, readable: false, value: '' }
    if (!isEncrypted(text)) return { encrypted: false, readable: true, value: text }
    if (!key) return { encrypted: true, readable: false, value: '' }

    const value = decryptStrict(text, key)
    return value === null ? { encrypted: true, readable: false, value: '' } : { encrypted: true, readable: true, value }
}

export const getSecretKey = () => localStorage.getItem(SECRET_KEY_STORAGE)

const parseRing = (raw) => {
    try {
        const parsed = JSON.parse(raw)
        return Array.isArray(parsed) ? parsed.filter((key) => typeof key === 'string' && key !== '') : []
    } catch {
        return []
    }
}

/**
 * Every key the user has entered, newest first. Notes encrypted under an older key stay
 * readable once its key has been seen, so nobody has to retype a key they already gave.
 * The active key lives in its own slot because other screens encrypt new notes with it.
 */
export const getSecretKeys = () => {
    const ring = parseRing(localStorage.getItem(SECRET_KEYS_STORAGE))
    const active = getSecretKey()
    return active ? [active, ...ring.filter((key) => key !== active)] : ring
}

// Single write path: storage events do not fire in the tab that writes, so anything
// rendering encrypted content listens for SECRET_KEY_EVENT instead.
export const saveSecretKey = (key) => {
    // The newest key becomes the active one AND joins the ring, so entering an old key
    // to read old notes never costs you access to the notes you could already read.
    const ring = getSecretKeys().filter((existing) => existing !== key)
    localStorage.setItem(SECRET_KEYS_STORAGE, JSON.stringify([key, ...ring]))
    localStorage.setItem(SECRET_KEY_STORAGE, key)
    window.dispatchEvent(new Event(SECRET_KEY_EVENT))
}
